export default function induction({ next, to, router, store }) {
  const inductionComplete = store.getters.authUser.induction_complete;

  if (!inductionComplete) {
    store.dispatch("getAuthUser").then(() => {
      if (!store.getters.authUser.induction_complete)
        return router.replace("/induction");
      else next();
    });
  } else {
    next(); // make sure to always call next()!
  }
}
